import PhoneInput from '../components/PhoneInput/PhoneInput';
import { OpenVippsApp } from '../components/OpenVippsApp/OpenVippsApp';
import QrBlock from '../components/QrBlock/QrBlock';
import Separator from '../components/Separator/Separator';
import OnlineShoppingIllustration from '../components/Illustrations/OnlineShoppingIllustration';
import ContinueAsCard from '../components/ContinueAsCard/ContinueAsCard';
import { useLanguageContext } from '../core/locale/LanguageContext';
import { currencyToDisplayString } from '../core/model/money';
import { PaymentType } from '../core/context/claims';
import type { InputViewChildProps } from './InputView.types';

const InputViewRedesigned = ({
  merchant,
  claims,
  isQrEligible,
  isNoEdit,
  initialMsisdn,
  error,
  loading,
  locale,
  shouldShowFancyDeeplinkButton,
  onSkippyClick,
  onSubmit,
  onUpdateCountry,
  initialRememberMe,
  initialNumberSource,
  showContinueAs,
  displayNumber,
  onContinueAs,
  onUseAnotherNumber,
}: InputViewChildProps): React.ReactNode => {
  const languageContext = useLanguageContext();

  const showPhoneSeparator = isQrEligible && !claims.blockPhoneNumberInput;

  const isAmountEmpty = !claims.amount;
  const heading =
    claims.paymentType === PaymentType.RECURRING || isAmountEmpty ?
      languageContext.getLocalizedText('inputHeadingRecurring', merchant.displayName)
    : languageContext.getLocalizedText(
        'inputHeadingAmount',
        currencyToDisplayString(
          { currency: claims.currency, value: claims.amount.toString() },
          locale
        ),
        merchant.displayName
      );

  return (
    <>
      <div className="input-view-header">
        <h1 className="input-view-heading">{heading}</h1>
        {!shouldShowFancyDeeplinkButton && (
          <p className="input-view-description">
            {languageContext.getLocalizedText(
              isQrEligible ? 'inputDescriptionQr' : 'inputDescription'
            )}
          </p>
        )}
      </div>

      {isQrEligible ?
        <>
          {showPhoneSeparator && (
            <div>
              <Separator />
              <span className="redesign-use-phone-text">
                {languageContext.getLocalizedText('qrSeparator')}
              </span>
            </div>
          )}
          <QrBlock />
        </>
      : <div className="input-view-illustration-wrapper">
          <OnlineShoppingIllustration className="input-view-illustration-img" />
        </div>
      }

      {shouldShowFancyDeeplinkButton ?
        <OpenVippsApp onClick={onSkippyClick} />
      : showContinueAs ?
        <ContinueAsCard
          displayNumber={displayNumber}
          loading={loading}
          onContinue={onContinueAs}
          onUseAnotherNumber={onUseAnotherNumber}
        />
      : !claims.blockPhoneNumberInput && (
          <PhoneInput
            onSubmit={onSubmit}
            noEdit={isNoEdit}
            initialMsisdn={initialMsisdn}
            onUpdateCountry={onUpdateCountry}
            error={error}
            loading={loading}
            initialRememberMe={initialRememberMe}
            initialNumberSource={initialNumberSource}
          />
        )
      }
    </>
  );
};

export default InputViewRedesigned;
